export default function registerNpsBanner(Alpine) {
  Alpine.data("npsBanner", (submitUrl, dismissUrl) => ({
    visible: true,
    submitted: false,
    selectedScore: null,

    submitScore(score) {
      this.selectedScore = score;
      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;

      fetch(submitUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "X-CSRF-Token": csrfToken,
          Accept: "application/json"
        },
        body: `score=${score}`
      }).then(() => {
        this.submitted = true;
        setTimeout(() => {
          this.visible = false;
        }, 2000);
      });
    },

    dismiss() {
      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;

      fetch(dismissUrl, {
        method: "POST",
        headers: {
          "X-CSRF-Token": csrfToken,
          Accept: "application/json"
        }
      }).then(() => {
        this.visible = false;
      });
    }
  }));
}
